import { Controller } from "@hotwired/stimulus";

import ReviewRenderer from "./review/reviewRenderer";

export default class extends Controller {
  static values = {
    formData: { type: Object, default: {} },
    responseData: { type: Object, default: {} },
  };

  static targets = ["reviewContainer"];

  async connect() {
    const surveyCore = await import("survey-core");
    const { Model } = surveyCore;
    const surveyModel = new Model(this.formDataValue);

    if (this.responseDataValue && Object.keys(this.responseDataValue).length > 0) {
      surveyModel.data = this.responseDataValue;
    }

    const renderer = new ReviewRenderer(surveyModel, { readOnly: true });
    renderer.renderInto(this.reviewContainerTarget);
  }
}
